import yup from './yup'
import moment from 'moment/moment'

export const sessionFromSchema = yup.object().shape({
  title: yup.string().label('Sub Event Title').trimmedRequired('Sub Event Title is required'),
  eventId: yup.string().label('Event').required('Event is required'),
  inheritVenue: yup.boolean(),
  venueId: yup
    .string()
    .label('Building')
    .when('inheritVenue', {
      is: true,
      then: yup.string(),
      otherwise: yup.string().required('Building is required')
    }),
  inheritTime: yup.boolean(),
  startDate: yup.date().label('Start Date').required().typeError('Invalid date'),
  endDate: yup
    .date()
    .label('End date')
    .typeError('Invalid date')
    .test('Date Check', 'End date must be after start date.', function (value) {
      const startDate = moment(this.parent.startDate)
      const endDate = moment(value)
      return endDate.isSameOrAfter(startDate, 'date')
    })
    .test('Time Check', 'End time must be after start time.', function (value) {
      const startDate = moment(this.parent.startDate)
      const endDate = moment(value)
      return endDate.isSameOrAfter(startDate)
    })
    .required(),
  moderators: yup.array().label('Moderators').nullable(),
  speakers: yup.array().label('Speakers').nullable(),
  sponsors: yup.array().label('Sponsors').nullable(),

  havePolls: yup.string().oneOf(['yes', 'no']),
  pollIds: yup.array().when('havePolls', {
    is: 'yes',
    then: yup.array().label('Associated Polls').min(1, 'Select at least one poll').required()
  }),
  keynotes: yup.string().label('Keynotes'),
  cardStyle: yup.string().label('Card Color')
})
